import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  receiptList: [],
  receiptOrderList: [],
  receiptDetail: [],
  loading: false,
  error: undefined,
};

const receiptSlice = createSlice({
  name: "receipt",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchReceiptList(state, action) {
      state.receiptList = action.payload;
      state.loading = false;
    },
    fetchReceiptOrderList(state, action) {
      state.receiptOrderList = action.payload;
      state.loading = false;
    },
    fetchReceiptDetail(state, action) {
      state.receiptDetail = action.payload;
      state.loading = false;
    },
  },
});

export const receiptActions = receiptSlice.actions;

export default receiptSlice.reducer;
